import { render, staticRenderFns } from "./NonMedical.vue?vue&type=template&id=d0681582&scoped=true"
import script from "./NonMedical.vue?vue&type=script&lang=js"
export * from "./NonMedical.vue?vue&type=script&lang=js"
import style0 from "./NonMedical.vue?vue&type=style&index=0&id=d0681582&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0681582",
  null
  
)

export default component.exports